import AuthMarketingLayout from "../components/auth/AuthMarketingLayout";

const SignUpPage = () => <AuthMarketingLayout mode="signup" />;

export default SignUpPage;
